const observer = new IntersectionObserver(
	(entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("in-view");
				observer.unobserve(entry.target);
			}
		});
	},
	{ rootMargin: "0px 0px -15% 0px" },
);
document.querySelectorAll(".watcher").forEach((el) => {
	observer.observe(el);
});
